import { flowRight } from 'lodash';
import { connect } from 'react-redux';

import * as CliAppDefinition from 'app/entities/CliAppDefinition';
import { currentAppDefinitionEntityId } from 'app/developer-v3/selectors';

import MainContent from './MainContent';

const mapStateToProps = state => {
  const currentAppDefinitionId = currentAppDefinitionEntityId(state);
  return {
    appHasLoaded: !!CliAppDefinition.selectors.all.entity(
      currentAppDefinitionId,
      state
    ),
  };
};

export default flowRight(connect(mapStateToProps))(MainContent);
